import { render } from "./SidebarFieldset.vue?vue&type=template&id=152d2c57"
import script from "./SidebarFieldset.vue?vue&type=script&lang=js"
export * from "./SidebarFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__